import { ConfirmFormStrategy } from '../confirm-form.interface';

export class RevokeInvitationStrategy implements ConfirmFormStrategy {
  readonly header = 'members-list.revoke-dialog.revoke-invitation';
  readonly message = 'members-list.revoke-dialog.are-you-sure-you-would-like-to-revoke-the-project';
  readonly confirmButtonLabel = 'members-list.revoke-dialog.revoke';
  readonly cancelButtonLabel = 'members-list.revoke-dialog.cancel';
}
